import { render, staticRenderFns } from "./qywx.vue?vue&type=template&id=2c297e2e&scoped=true&"
import script from "./qywx.vue?vue&type=script&lang=js&"
export * from "./qywx.vue?vue&type=script&lang=js&"
import style0 from "./qywx.vue?vue&type=style&index=0&id=2c297e2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c297e2e",
  null
  
)

export default component.exports